
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, class_type, list_type, bool_type, record_type, option_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ReceiverTypeName, User_$reflection } from "../../Shared/User.js";
import { RequestedValue$1, CustomerConfiguration_$reflection, AccountSettings_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { PropertyConfigurationVisibility, PropertyConfiguration_$reflection } from "../../Shared/PropertyConfiguration.js";
import { Location_$reflection } from "../../Shared/Location.js";
import { contains, filter, append as append_1, ofArray, map as map_1, toArray as toArray_1, tryFind, singleton as singleton_1, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { toArray, empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { addPrefix as addPrefix_1, fetchWithDecoder as fetchWithDecoder_1 } from "../../Communication.js";
import { getAccountSettings } from "../../Requests/Customer.js";
import { getCustomerConfiguration } from "../../Requests/Configuration.js";
import { Cmd_errorToast } from "../../Components/Toast.js";
import { unwrap, map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { stringHash, createObj, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { roleToString } from "../../Shared/Helper.js";
import { Table_customPropertyColumnDefinitions } from "../../Widgets/CustomProperties.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";
import User_Add_Plus from "../../../public/assets/icons/User_Add_Plus.svg";
import { TableControlElement$1, TableControl$1 } from "../../Widgets/Table/Table.js";
import { usePermissions } from "../../UserPermissions.js";
import { Permissions_has, Permission, Permissions_allowsReceiverType } from "../../Shared/Roles.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Skeleton } from "../../Components/Skeleton.js";

class WatcherRow extends Record {
    constructor(UserId, Name, User) {
        super();
        this.UserId = UserId;
        this.Name = Name;
        this.User = User;
    }
}

function WatcherRow_$reflection() {
    return record_type("Tools.Dialogs.ProblemReportWatcherModal.WatcherRow", [], WatcherRow, () => [["UserId", string_type], ["Name", string_type], ["User", option_type(User_$reflection())]]);
}

class Access extends Record {
    constructor(Users, Locations, CustomFields) {
        super();
        this.Users = Users;
        this.Locations = Locations;
        this.CustomFields = CustomFields;
    }
}

function Access_$reflection() {
    return record_type("Tools.Dialogs.ProblemReportWatcherModal.Access", [], Access, () => [["Users", bool_type], ["Locations", bool_type], ["CustomFields", bool_type]]);
}

class State extends Record {
    constructor(Access, Users, PropertyConfigurations, Locations, BusinessUnitsEnabled, Currency) {
        super();
        this.Access = Access;
        this.Users = Users;
        this.PropertyConfigurations = PropertyConfigurations;
        this.Locations = Locations;
        this.BusinessUnitsEnabled = BusinessUnitsEnabled;
        this.Currency = Currency;
    }
}

function State_$reflection() {
    return record_type("Tools.Dialogs.ProblemReportWatcherModal.State", [], State, () => [["Access", Access_$reflection()], ["Users", RequestedValue$1_$reflection(list_type(User_$reflection()))], ["PropertyConfigurations", RequestedValue$1_$reflection(list_type(PropertyConfiguration_$reflection()))], ["Locations", RequestedValue$1_$reflection(list_type(Location_$reflection()))], ["BusinessUnitsEnabled", RequestedValue$1_$reflection(bool_type)], ["Currency", RequestedValue$1_$reflection(option_type(string_type))]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UsersFetched", "UsersFailed", "PropertyConfigurationsFetched", "PropertyConfigurationsFailed", "LocationsFetched", "LocationsFailed", "AccountSettingsFetched", "AccountSettingsFailed", "CustomerConfigurationFetched", "CustomerConfigurationFailed"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.Dialogs.ProblemReportWatcherModal.Msg", [], Msg, () => [[["Item", list_type(User_$reflection())]], [["Item", class_type("System.Exception")]], [["Item", list_type(PropertyConfiguration_$reflection())]], [["Item", class_type("System.Exception")]], [["Item", list_type(Location_$reflection())]], [["Item", class_type("System.Exception")]], [["Item", AccountSettings_$reflection()]], [["Item", class_type("System.Exception")]], [["Item", CustomerConfiguration_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

function init(isOpen, permittedAccess) {
    const access = new Access(permittedAccess.Users, permittedAccess.Users && permittedAccess.Locations, permittedAccess.Users && permittedAccess.CustomFields);
    const pendingIf = (condition) => {
        if (condition) {
            return new RequestedValue$1(0, []);
        }
        else {
            return new RequestedValue$1(1, [empty()]);
        }
    };
    return [new State(access, pendingIf(access.Users), pendingIf(access.CustomFields), pendingIf(access.Locations), new RequestedValue$1(0, []), new RequestedValue$1(0, [])), isOpen ? Cmd_batch(toList(delay(() => append(access.Users ? singleton(Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(User_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/receivers/users", (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(1, [Item_1])))) : empty_1(), delay(() => append(access.CustomFields ? singleton(Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_5;
        return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
            const pr_1 = response_2.arrayBuffer();
            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(PropertyConfiguration_$reflection())));
        }, refreshOn_1)))(true).then((_arg_1) => {
            const result_3 = _arg_1;
            return (result_3.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_3.fields[0]);
            })())) : (Promise.resolve(result_3.fields[0]));
        });
    })), "/api/property-configurations", (Item_2) => (new Msg(2, [Item_2])), (Item_3) => (new Msg(3, [Item_3])))) : empty_1(), delay(() => append(access.Locations ? singleton(Cmd_OfPromise_either((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(url_6), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_4) => {
        const pr_2 = response_4.arrayBuffer();
        return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), list_type(Location_$reflection())));
    })))), "/api/locations", (Item_4) => (new Msg(4, [Item_4])), (Item_5) => (new Msg(5, [Item_5])))) : empty_1(), delay(() => append(singleton(getAccountSettings((Item_6) => (new Msg(6, [Item_6])), (Item_7) => (new Msg(7, [Item_7])))), delay(() => singleton(getCustomerConfiguration((Item_8) => (new Msg(8, [Item_8])), (Item_9) => (new Msg(9, [Item_9]))))))))))))))) : Cmd_none()];
}

const failedCmd = Cmd_errorToast("general.a_error_occured");

function update(msg, state) {
    let bind$0040, bind$0040_1, bind$0040_2;
    switch (msg.tag) {
        case 1:
            return [new State((bind$0040 = state.Access, new Access(false, bind$0040.Locations, bind$0040.CustomFields)), new RequestedValue$1(1, [empty()]), state.PropertyConfigurations, state.Locations, state.BusinessUnitsEnabled, state.Currency), failedCmd];
        case 2:
            return [new State(state.Access, state.Users, new RequestedValue$1(1, [msg.fields[0]]), state.Locations, state.BusinessUnitsEnabled, state.Currency), Cmd_none()];
        case 3:
            return [new State((bind$0040_1 = state.Access, new Access(bind$0040_1.Users, bind$0040_1.Locations, false)), state.Users, new RequestedValue$1(1, [empty()]), state.Locations, state.BusinessUnitsEnabled, state.Currency), failedCmd];
        case 4:
            return [new State(state.Access, state.Users, state.PropertyConfigurations, new RequestedValue$1(1, [msg.fields[0]]), state.BusinessUnitsEnabled, state.Currency), Cmd_none()];
        case 5:
            return [new State((bind$0040_2 = state.Access, new Access(bind$0040_2.Users, false, bind$0040_2.CustomFields)), state.Users, state.PropertyConfigurations, new RequestedValue$1(1, [empty()]), state.BusinessUnitsEnabled, state.Currency), failedCmd];
        case 6:
            return [new State(state.Access, state.Users, state.PropertyConfigurations, state.Locations, new RequestedValue$1(1, [msg.fields[0].BusinessUnitsEnabled]), state.Currency), Cmd_none()];
        case 7:
            return [new State(state.Access, state.Users, state.PropertyConfigurations, state.Locations, new RequestedValue$1(1, [false]), state.Currency), failedCmd];
        case 8:
            return [new State(state.Access, state.Users, state.PropertyConfigurations, state.Locations, state.BusinessUnitsEnabled, new RequestedValue$1(1, [msg.fields[0].Currency])), Cmd_none()];
        case 9:
            return [new State(state.Access, state.Users, state.PropertyConfigurations, state.Locations, state.BusinessUnitsEnabled, new RequestedValue$1(1, [undefined])), failedCmd];
        default:
            return [new State(state.Access, new RequestedValue$1(1, [msg.fields[0]]), state.PropertyConfigurations, state.Locations, state.BusinessUnitsEnabled, state.Currency), Cmd_none()];
    }
}

function userText(accessor, row) {
    return new CellContent(0, [defaultArg(map(accessor, row.User), "")]);
}

function WatcherTable(props) {
    let elems_1, elems, TableRows, Options;
    const t = useTranslation()[0];
    const columnDefinitions = toArray(delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (row) => (new CellContent(0, [row.Name])), "text", "text")), delay(() => (props.Access.Users ? append(singleton(new ColumnDefinition$1("personnelNumber", "", t("user.personnel_number"), (row_1) => userText((_arg) => _arg.PersonnelNumber, row_1), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("emailPhoneNumber", "", t("user.email_mobile_number"), (row_2) => userText((user) => {
        const matchValue = user.LoginInformation;
        if (matchValue.tag === 1) {
            return matchValue.fields[0];
        }
        else {
            return matchValue.fields[0];
        }
    }, row_2), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("department", "", t("user.department"), (row_3) => userText((_arg_1) => _arg_1.Department, row_3), "select", "text")), delay(() => append(props.Access.Locations ? singleton(new ColumnDefinition$1("location", "", t("general.location"), (row_4) => userText((user_1) => defaultArg(map((_arg_2) => _arg_2.Name, tryFind((location) => equals(location.Id, user_1.LocationId), props.Locations)), ""), row_4), "select", "text")) : empty_1(), delay(() => append(props.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnitName", "", t("business_units.business_unit"), (row_5) => userText((user_2) => defaultArg(user_2.BusinessUnitNames, ""), row_5), "select", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("role", "", t("general.role"), (row_6) => userText((user_3) => t(concat("role.", ...roleToString(user_3.Role))), row_6), "select", "text")), delay(() => {
        let currency;
        const matchValue_1 = props.Currency;
        let matchResult, currency_1;
        if (matchValue_1 != null) {
            if ((currency = matchValue_1, props.Access.CustomFields)) {
                matchResult = 0;
                currency_1 = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return Table_customPropertyColumnDefinitions(props.PropertyConfigurations, t("tool.custom_properties"), (row_7) => defaultArg(map((_arg_3) => _arg_3.CustomProperties, row_7.User), empty()), t, currency_1);
            default: {
                return empty_1();
            }
        }
    })))))))))))) : empty_1())))));
    return reactElement("div", createObj(ofArray([["data-test-id", "problem-report-watcher-modal"], ["className", join(" ", ["flex", "flex-col", "gap-4", "px-4", "pb-4", "h-full"])], (elems_1 = [reactElement("p", {
        className: join(" ", ["text-sm", "text-gray-600"]),
        children: t("tool.problem_report_watchers_description"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "min-h-0"])], (elems = [createElement(InfiniteTable, (TableRows = toArray_1(props.Rows), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: true,
        CustomTableFilters: false,
        DefaultSortColumn: ["name", "asc"],
        Fullscreen: false,
        GlobalSearch: true,
        RowSelection: "multiRow",
        SaveTableConfiguration: true,
        WithQueryParameters: false,
    }, {
        ColumnDefinitions: columnDefinitions,
        Controls: singleton_1(new TableControlElement$1(0, [new TableControl$1(t("general.add"), User_Add_Plus(), (props.ComponentState === "disabled") ? undefined : ((rows) => {
            props.OnAdd(map_1((_arg_4) => _arg_4.UserId, rows));
        }), true, false, "problem-report-watcher-modal-add")])),
        Options: Options,
        TableKey: "problem-report-watcher-modal-table",
        TableRows: TableRows,
    })))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ProblemReportWatcherModal(props) {
    let matchValue, matchValue_1, matchValue_2, matchValue_3, matchValue_4, excludedIds, rows;
    const patternInput = useTranslation();
    const permissions = usePermissions();
    const access = new Access(Permissions_allowsReceiverType(permissions, new Permission(41, []), new ReceiverTypeName(0, [])), Permissions_has(permissions, new Permission(69, [])), Permissions_has(permissions, new Permission(78, [])));
    const state_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.IsOpen, access), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen])[0];
    return createElement(ModalSheet, {
        CloseButtonTestId: "problem-report-watcher-modal-close",
        Content: (matchValue = state_1.Users, (matchValue_1 = state_1.PropertyConfigurations, (matchValue_2 = state_1.Locations, (matchValue_3 = state_1.BusinessUnitsEnabled, (matchValue_4 = state_1.Currency, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_1.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_2.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_3.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_4.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((excludedIds = append_1(props.ExistingWatcherIds, props.ParticipantIds), (rows = map_1((candidate_1) => (new WatcherRow(candidate_1.UserId, candidate_1.Name, tryFind((user) => (user.Id === candidate_1.UserId), matchValue.fields[0]))), filter((candidate) => !contains(candidate.UserId, excludedIds, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        }), props.Candidates)), createElement(WatcherTable, {
            Access: state_1.Access,
            BusinessUnitsEnabled: matchValue_3.fields[0],
            ComponentState: props.ComponentState,
            Currency: unwrap(matchValue_4.fields[0]),
            Locations: matchValue_2.fields[0],
            OnAdd: props.OnAdd,
            PropertyConfigurations: filter((configuration) => equals(configuration.Visibility, new PropertyConfigurationVisibility(2, [])), matchValue_1.fields[0]),
            Rows: rows,
        }))))))))))))),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: patternInput[0]("tool.problem_report_add_watcher"),
        ZIndex: 30,
    });
}

